import { useState } from 'react'
import { useQueryClient } from 'react-query'
import { useDashboardAuditReports } from 'api/hooks/use-dashboard-audit-reports'
import SampleList from './sample-list'
import SampleDetail from './sample-detail'

const SamplesTab = ({ dashboardId, params, canEdit }) => {
  const [selectedSampleId, setSelectedSampleId] = useState(null)
  const queryClient = useQueryClient()

  const { isLoading, data: samples } = useDashboardAuditReports({
    dashboardId,
    options: {}
  })

  const handleSelectSample = (sampleId) => {
    setSelectedSampleId(sampleId)
  }

  const handleBack = () => {
    setSelectedSampleId(null)
  }

  const handleSampleCreated = (sampleId) => {
    queryClient.invalidateQueries(['dashboard-audit-reports', dashboardId])
    setSelectedSampleId(sampleId)
  }

  if (selectedSampleId) {
    return (
      <SampleDetail
        sampleId={selectedSampleId}
        onBack={handleBack}
        dashboardId={dashboardId}
      />
    )
  }

  return (
    <SampleList
      samples={samples}
      isLoading={isLoading}
      dashboardId={dashboardId}
      params={params}
      canEdit={canEdit}
      onSelectSample={handleSelectSample}
      onSampleCreated={handleSampleCreated}
    />
  )
}

export default SamplesTab
